<template src="./reports.html"></template>
<script>
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import Axios from "axios";
import $ from "jquery";
import { GChart } from "vue-google-charts";
import * as Chartist from "chartist";
import GetcurrencySymbol from "@/assets/js/currency_sign.js";
var moment = require("moment");

let VehicleByTypeData = "";
let DriverByTypeData = "";
let VehicleAssignData = "";
let DriverAssignData = "";
let CheckFailureByCheckData = "";
let CheckFailureByDriverData = "";
let VehiclesByAgeData = "";
let DriverPointsData = "";
let ExpiryDatesData = "";
let warningData = "";
let failureData = "";
export default {
  components: {
    VueGallery,
    Multiselect,
    GChart,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      currency_type : GetcurrencySymbol(),
      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      driverFitList: false,
      driverUnfitList: false,
      vehiclesafeList: false,
      vehiclesafewithwarningList: false,
      vehicleunsafeList: false,
      vehicleAssignList: false,
      vehicleUnassignList: false,
      driverAssignList: false,
      driverUnassignList: false,
      vehiclesByAgeList: false,
      driversPointsList: false,
      expiryDatesList: false,
      warningFailureList: false,
      showVehicleDetails: false,
      showOwnerDetails: false,
      checkFailureByCheckList: false,
      checkFailureByDriverList: false,
      ShowDashboardDetailPopup: false,
      assetsModule: false,
      branchModuleEnable: false,
      processingLoader: false,
      days: 0,
      DashboardDetailHeading: "",
      ExpiryType: "",
      MileageUnit: "Mileage",
      VehicleByAgeList: [],
      DriverPointsList: [],
      ExpiryDatesList: [],
      CheckFailureByCheckArray: [],
      WarningFailureDataArray: [],
      CheckFailureByDriverArray: [],
      CheckFailureByCheckDriverList: [],
      CheckFailureByCheckNameList: [],
      VehicleByAgeArray: [],
      DriverPointsArray: [],
      ExpiryDatesArray: [],
      excel_data: [],
      MonthDays: "",
      fromYear: "",
      VehicleCheckFilter: {
        vehicles: [],
        filterMonth: "",
        filterYear: "",
        filterDeletedVehicles: false,
        filterGroup: "",
        branch_id: "",
      },
      AssetCheckFilter: {
        assets: [],
        filterMonth: "",
        filterYear: "",
        filterDeletedAssets: false,
        filterGroup: "",
        branch_id: "",
      },
      excel_title: "",
      TotalStatsSearch: {
        fromDate: "",
        toDate: "",
      },
      TotalStats: [],

      CheckFailuresSearch: {
        fromDate: "",
        toDate: "",
      },
      CheckFailures: [],
      CheckFailuresByDrivers: [],

      TotalExpireSearch: {
        fromDate: "",
        toDate: "",
      },
      TotalExpire: [],

      TotalWarningFailure: [],
      DashboardReportData: {},
      DashboardData: [],
      DashboardReport: [],
      DriverAssignedVehicles: [],
      ViewVehicleDetails: [],
      ViewOwnerDetails: [],
      VehicleSafetyStats: [],
      DriverSafetyStats: [],
      VehicleAssignment: [],
      DriverAssignment: [],
      DriverPoints: [],
      VehiclesByAge: [],
      WarningFailureDriverList: [],
      Vehicles: [],
      AllVehicles: [],
      AllAssets: [],
      VehiclesByCost: [],
      VehiclesByMileage: [],
      VehicleCheckList: [],
      AssetCheckList: [],
      asset_check_data: [],
      Groups:[],
      AssetGroups:[],
      Branches: {},
      VehiclesByMileageSearch: {
        VehicleId: "0",
      },
      VehicleSafetyChart: {
        chartData: [["Task", ""]],
        options: {
          width: "100%",
          height: 300,
          //is3D: true,
          pieHole: 0.5,
          tooltip: true,
          colors: ["#DC3545", "#3F901D", "#f8d62b"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              VehicleByTypeData = selection[1];
            }
          },
        },
      },
      DriverSafetyChart: {
        chartData: [["Task", ""]],
        options: {
          width: "100%",
          height: 300,
          pieHole: 0.5,
          colors: ["#3f901d", "#dc3545"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              DriverByTypeData = selection[1];
            }
          },
        },
      },
      VehicleAssignmentChart: {
        chartData: [["Task", ""]],
        options: {
          width: "100%",
          height: 300,
          pieHole: 0.5,
          colors: ["#3f901d", "#dc3545"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              VehicleAssignData = selection[1];
            }
          },
        },
      },
      DriverAssignmentChart: {
        chartData: [["Task", ""]],
        options: {
          width: "100%",
          height: 300,
          pieHole: 0.5,
          colors: ["#3f901d", "#dc3545"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              DriverAssignData = selection[1];
            }
          },
        },
      },
      CheckFailureByCheckChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              CheckFailureByCheckData = selection[1];
            }
          },
        },
      },
      CheckFailureByDriverChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          click: function (e) {
            var selection = e.targetID.split("#");
            if (typeof selection[1] != "undefined") {
              CheckFailureByDriverData = selection[1];
            }
          },
        },
      },
      VehicleByAgeChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          select: () => {
            const table = this.$refs.gChart.chartObject;
            const selection = table.getSelection();
            if (typeof selection[0] != "undefined") {
              VehiclesByAgeData = selection[0].row;
              this.selectedVehiclesByAge(VehiclesByAgeData);
            }
          },
        },
      },
      DriverPointsChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          select: () => {
            const table = this.$refs.gChart2.chartObject;
            const selection = table.getSelection();
            if (typeof selection[0] != "undefined") {
              DriverPointsData = selection[0].row;
              this.selectedDriverPoints(DriverPointsData);
            }
          },
        },
      },
      ExpiryDatesChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          select: () => {
            const table = this.$refs.gChart3.chartObject;
            const selection = table.getSelection();
            if (typeof selection[0] != "undefined") {
              ExpiryDatesData = selection[0].row;
              this.selectedExpiryDates(ExpiryDatesData);
            }
          },
        },
      },
      TotalWarningFailureChart: {
        chartData: [["Task", ""]],
        options: {
          bars: "vertical",
          vAxis: {
            format: "decimal",
          },
          height: 300,
          width: "100%",
          colors: ["#7366ff", "#f73164", "#51bb25"],
        },
        chartEvents: {
          select: () => {
            const table = this.$refs.gChart4.chartObject;
            const selection = table.getSelection();
            if (typeof selection[0] != "undefined") {
              warningData = selection[0].row;
              failureData = selection[0].column;
              this.selectedWarningFailures(warningData, failureData);
            }
          },
        },
      },
      MileageAreaChartOptions: {
        //title: 'Company Performance',
        hAxis: { title: "Date", titleTextStyle: { color: "#333" } },
        vAxis: { title: "Mileage", titleTextStyle: { color: "#333" } },
        width: "100%",
        height: 300,
        colors: ["#7366ff", "#f73164"],
      },
      CostAreaChartOptions: {
        //title: 'Company Performance',
        hAxis: { title: "Date", titleTextStyle: { color: "#333" } },
        vAxis: { title: "Cost($)", titleTextStyle: { color: "#333" } },
        width: "100%",
        height: 300,
        colors: ["#7366ff", "#f73164"],
      },
      CostSVGChartOptions: {
        options: {
          low: 0,
          showArea: true,
          showPoint: true,
          fullWidth: true,
        },
        eventHandlers: [
          {
            event: "draw",
            fn(data) {
              if (data.type === "line" || data.type === "area") {
                data.element.animate({
                  d: {
                    begin: 2000 * data.index,
                    dur: 2000,
                    from: data.path
                      .clone()
                      .scale(1, 0)
                      .translate(0, data.chartRect.height())
                      .stringify(),
                    to: data.path.clone().stringify(),
                    easing: Chartist.Svg.Easing.easeOutQuint,
                  },
                });
              }
            },
          },
        ],
      },

      areaspalinechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: ["#7366ff", "#f73164"],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );

    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    this.assetsModule = FleetSubscriptionModules["Assets"];
    if (FleetSubscriptionModules["Branches"]) {
      this.branchModuleEnable = true;
    }
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions.Reports || !AccountPermissions.Reports.enable)
    ) {
      this.$router.push("/");
    }

    this.fromYear = moment().year() - 6;
    document.title = pbx_SiteTitle + " - Reports";
    //this.GetTotalStats();
    this.GetVehicleSafetyStats();
    this.GetTotalExpires();
    //this.GetDashBoardData();
    this.GetDriverPoints();
    this.GetCheckFailures();
    this.GetTotalWarningFailure();
    this.GetVehiclesByAge();
    this.GetVehiclesListForAssign();
    this.GetVehiclesListAll();
    this.GetAssetsList();
    this.GetVehicleCheckData();
    if (this.assetsModule) {
      this.GetAssetCheckData();
    }
    this.GetGroups();
    this.GetBranches();
    var Company = JSON.parse(localStorage.getItem("Company"));
    if (Company && Company.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },

  methods: {
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    GetGroups() {
      var obj = {
        token: localStorage.getItem("token"),
      };
      // Get Vehicle Groups
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.Groups = Response.data.records;
        }
      });
      
      // Get Asset Groups
      if(this.assetsModule) {
          Axios.post(Endpoints.Assets.Group.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.AssetGroups = Response.data.GroupList;
          }
        });
      }
      
    },
    GetAssetsList() {
      Axios.post(Endpoints.Assets.List, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.AllAssets = Response.data.AssetsList || [];
        }
      });
    },
    GetVehicleCheckData() {
      this.processingLoader = true;
      this.vehicle_check_data = [];
      Axios.post(Endpoints.Report.VehicleCheckList, {
        token: localStorage.getItem("token"),
        search_key: this.VehicleCheckFilter,
      }).then((Response) => {
        this.processingLoader = false;
        if (Response?.data?.success) {
          this.VehicleCheckFilter.filterMonth = Response.data.month;
          this.VehicleCheckFilter.filterYear = Response.data.year;
          this.VehicleCheckFilter.filterDeletedVehicles = Response.data.deleted_vehicle;
          this.days = Response.data.days;
          this.VehicleCheckList = Response.data.result;
          this.MonthDays = Response.data.month_days;
          this.VehicleCheckList.forEach((element) => {
            var obj = {};

            obj["VRM"] = element.vrm;
            obj["Driver"] = element.assigned_driver;
            obj["Current Mileage"] = element.current_mileage;
            if (this.branchModuleEnable) {
              obj["Branch"] = element.branch;
            }
            obj["Group"] = element.group;
            element.data.forEach((element2) => {
              var finalResult = "";
              if (element2.result.length == 0) {
                finalResult = "-";
              }
              element2.result.forEach((element3) => {
                if (element3.safe == 1 && element3.warning != 1) {
                  var Pass = "Safe";
                  if(parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)){
                    Pass = "Safe"+" ("+element3.forename+" "+element3.surname+")";
                  }
                  
                  finalResult =
                    finalResult != "" ? finalResult + " | "+Pass : Pass;
                }
                
                if (element3.safe == 0) {
                  var Fail = "Unsafe";
                  if(parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)){
                    Fail = "Unsafe"+" ("+element3.forename+" "+element3.surname+")";
                  }

                  finalResult =
                    finalResult != "" ? finalResult + " | "+Fail : Fail;
                }
                if (element3.safe == 1 && element3.warning == 1) {
                  var Warning = "Warning";
                  if(parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)){
                    Warning = "Warning"+" ("+element3.forename+" "+element3.surname+")";
                  }
                  finalResult =
                    finalResult != "" ? finalResult + " | " + Warning: Warning;
                }
              });
              obj[element2.date + "-" + element2.month + "-" + element2.year] =
                finalResult;
            });
            this.vehicle_check_data.push(obj);
          });
        }
      });
    },
    GetAssetCheckData() {
      this.processingLoader = true;
      this.asset_check_data = [];
      Axios.post(Endpoints.Report.AssetCheckList, {
        token: localStorage.getItem("token"),
        search_key: this.AssetCheckFilter,
      }).then((Response) => {
        this.processingLoader = false;
        if (Response?.data?.success) {
          this.AssetCheckFilter.filterMonth = Response.data.month;
          this.AssetCheckFilter.filterYear = Response.data.year;
          this.AssetCheckFilter.filterDeletedAssets = Response.data.deleted_vehicle;
          this.days = Response.data.days;
          this.AssetCheckList = Response.data.result;
          this.MonthDays = Response.data.month_days;
          this.AssetCheckList.forEach((element) => {
            var obj = {};

            obj["Asset"] = element.name;
            obj["Category"] = element.category;
            obj["Sub Category"] = element.sub_category;
            obj["Current Hours"] = element.current_hours;
            obj["Current Miles"] = element.current_miles;
            obj["Driver"] = element.assigned_driver;
            if (this.branchModuleEnable) {
              obj["Branch"] = element.branch;
            }
            obj["Group"] = element.group;
            element.data.forEach((element2) => {
              var finalResult = "";
              if (element2.result.length == 0) {
                finalResult = "-";
              }
              element2.result.forEach((element3) => {
                if (element3.value == 1 && element3.warning != 1) {
                  var Pass = "Safe";
                  if (parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)) {
                    Pass = "Safe" + " (" + element3.forename + " " + element3.surname + ")";
                  }

                  finalResult =
                    finalResult != "" ? finalResult + " | " + Pass : Pass;
                }

                if (element3.value == 2) {
                  var Fail = "Unsafe";
                  if (parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)) {
                    Fail = "Unsafe" + " (" + element3.forename + " " + element3.surname + ")";
                  }

                  finalResult =
                    finalResult != "" ? finalResult + " | " + Fail : Fail;
                }
                if (element3.value == 1 && element3.warning == 1) {
                  var Warning = "Warning";
                  if (parseInt(element3.driver_id) != parseInt(element.assigned_driver_id)) {
                    Warning = "Warning" + " (" + element3.forename + " " + element3.surname + ")";
                  }
                  finalResult =
                    finalResult != "" ? finalResult + " | " + Warning : Warning;
                }
              });
              obj[element2.date + "-" + element2.month + "-" + element2.year] =
                finalResult;
            });
            this.asset_check_data.push(obj);
          });
        }
      });
    },
    GetVehicleSafetyStats() {
      Axios.post(Endpoints.Dashboard.DashboardReport, {
        token: localStorage.getItem("token"),
        type: "all",
        vehicle_join: "Driver",
      }).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReport = Response.data.DashboardReport;

          this.VehicleSafetyChart.chartData.push(["", ""]);
          this.VehicleSafetyChart.chartData.push([
            "Safe",
            {
              v: this.DashboardReport.VehicleSafe,
              f: this.DashboardReport.VehicleSafe,
            },
          ]);
          this.VehicleSafetyChart.chartData.push([
            "Safe with Warning",
            {
              v: this.DashboardReport.VehicleWarning,
              f: this.DashboardReport.VehicleWarning,
            },
          ]);
          this.VehicleSafetyChart.chartData.push([
            "Unsafe",
            {
              v: this.DashboardReport.VehicleUnSafe,
              f: this.DashboardReport.VehicleUnSafe,
            },
          ]);

          this.DriverSafetyChart.chartData = [];
          this.DriverSafetyChart.chartData.push(["", ""]);
          this.DriverSafetyChart.chartData.push([
            "Fit",
            {
              v: this.DashboardReport.TotalfitDriver,
              f: this.DashboardReport.TotalfitDriver,
            },
          ]);
          this.DriverSafetyChart.chartData.push([
            "UnFit with Warning",
            {
              v: this.DashboardReport.TotalUnfitDriver,
              f: this.DashboardReport.TotalUnfitDriver,
            },
          ]);

          this.VehicleAssignmentChart.chartData = [];
          this.VehicleAssignmentChart.chartData.push(["", ""]);
          this.VehicleAssignmentChart.chartData.push([
            "Assigned",
            {
              v: this.DashboardReport.VehicleAssigned,
              f: this.DashboardReport.VehicleAssigned,
            },
          ]);
          this.VehicleAssignmentChart.chartData.push([
            "UnAssigned",
            {
              v: this.DashboardReport.VehicleUnassigned,
              f: this.DashboardReport.VehicleUnassigned,
            },
          ]);

          this.DriverAssignmentChart.chartData = [];
          this.DriverAssignmentChart.chartData.push(["", ""]);
          this.DriverAssignmentChart.chartData.push([
            "Assigned",
            {
              v: this.DashboardReport.TotalAssignedDriver,
              f: this.DashboardReport.TotalAssignedDriver,
            },
          ]);
          this.DriverAssignmentChart.chartData.push([
            "UnAssigned",
            {
              v: this.DashboardReport.TotalUsAssignedDriver,
              f: this.DashboardReport.TotalUsAssignedDriver,
            },
          ]);
        }
      });
    },
    GetDashBoardData() {
      Axios.post(Endpoints.Dashboard.DashboardData, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.DashboardData;
          this.DashboardData = Response.data.DashboardData;
          this.VehicleSafetyStats = [];
          /*this.VehicleSafetyStats.push(['','',{type: 'string', role: 'tooltip', p: {html: true}}]);
	            this.VehicleSafetyStats.push(['Safe',data['VehicleSafeWithOutWarning'],'<div style="padding:5px 5px 5px 5px;">ADR123 <br/>VRM563</div>']);
	            this.VehicleSafetyStats.push(['Safe',{v: data['VehicleSafeWithOutWarning'], f: 'ADR123, VRM563'}]);*/

          /*this.VehicleSafetyStats.push(['','']);
	            this.VehicleSafetyStats.push(['Safe',data['VehicleSafeWithOutWarning']]);
	            this.VehicleSafetyStats.push(['Safe with Warning',data['VehicleWarning']]);
	            this.VehicleSafetyStats.push(['UnSafe',data['VehicleUnSafe']]);*/
        }
      });
    },
    ShowVehicleDetail(VehicleDetails) {
      this.showOwnerDetails = false;
      this.showVehicleDetails = true;
      this.ViewVehicleDetails = VehicleDetails;
    },
    ShowOwnerDetail(OwnerDetails) {
      this.showVehicleDetails = false;
      this.showOwnerDetails = true;
      this.ViewOwnerDetails.name =
        OwnerDetails.driver_name && OwnerDetails.driver_phone
          ? OwnerDetails.driver_name
          : OwnerDetails.forename + " " + OwnerDetails.surname;
      this.ViewOwnerDetails.phone =
        OwnerDetails.driver_name && OwnerDetails.driver_phone
          ? OwnerDetails.driver_phone
          : OwnerDetails.phone;
      this.ViewOwnerDetails.email =
        OwnerDetails.driver_name && OwnerDetails.driver_email
          ? OwnerDetails.driver_email
          : OwnerDetails.email;
    },
    setAllPopupStatus() {
      this.driverFitList = false;
      this.driverUnfitList = false;
      this.vehiclesafeList = false;
      this.vehiclesafewithwarningList = false;
      this.vehicleunsafeList = false;
      this.vehicleAssignList = false;
      this.vehicleUnassignList = false;
      this.driverAssignList = false;
      this.driverUnassignList = false;
      this.showVehicleDetails = false;
      this.showOwnerDetails = false;
      this.checkFailureByCheckList = false;
      this.checkFailureByDriverList = false;
      this.vehiclesByAgeList = false;
      this.driversPointsList = false;
      this.expiryDatesList = false;
      this.warningFailureList = false;
      return true;
    },
    selectedWarningFailures(warningData, failureData) {
      if (warningData >= 0 && failureData > 0) {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (failureData == 1) {
          this.WarningFailureDriverList =
            this.WarningFailureDataArray[warningData].warningDriverArr;
          this.DashboardDetailHeading =
            this.WarningFailureDataArray[warningData].month + " Month Warnings";
          this.excel_title =
            this.WarningFailureDataArray[warningData].month +
            "-month-warnings-list";
        }
        if (failureData == 2) {
          this.WarningFailureDriverList =
            this.WarningFailureDataArray[warningData].failureDriverArr;
          this.DashboardDetailHeading =
            this.WarningFailureDataArray[warningData].month + " Month Failures";
          this.excel_title =
            this.WarningFailureDataArray[warningData].month +
            "-month-failures-list";
        }
        this.WarningFailureDriverList.forEach((element) => {
          var obj = {};
          obj["Driver"] = element.driver_name;
          obj["Vehicle"] = element.vrm;
          obj["Notes"] = element.notes;
          this.excel_data.push(obj);
        });
        this.ShowDashboardDetailPopup = true;
        this.warningFailureList = true;
      }
      warningData = "";
      failureData = "";
    },
    selectedExpiryDates(ExpiryDatesData) {
      if (ExpiryDatesData >= 0) {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (ExpiryDatesData == 0) {
          this.ExpiryDatesList = this.ExpiryDatesArray.mot_due_Arr;
          this.DashboardDetailHeading = "MOT Expiry Dates";
          this.excel_title = "mot-expiry-date-list";
          this.ExpiryType = "MOT";
        }
        if (ExpiryDatesData == 1) {
          this.ExpiryDatesList = this.ExpiryDatesArray.tax_due_Arr;
          this.DashboardDetailHeading = "TAX Expiry Dates";
          this.excel_title = "tax-expiry-date-list";
          this.ExpiryType = "TAX";
        }
        if (ExpiryDatesData == 2) {
          this.ExpiryDatesList = this.ExpiryDatesArray.insurance_expiry_Arr;
          this.DashboardDetailHeading = "Insurance Expiry Dates";
          this.excel_title = "insurance-expiry-date-list";
          this.ExpiryType = "Insurance";
        }
        if (ExpiryDatesData == 3) {
          this.ExpiryDatesList = this.ExpiryDatesArray.nextservice_date_Arr;
          this.DashboardDetailHeading = "Service Expiry Dates";
          this.excel_title = "service-expiry-date-list";
          this.ExpiryType = "Service";
        }
        if (ExpiryDatesData == 4) {
          this.ExpiryDatesList = this.ExpiryDatesArray.license_expiry_Arr;
          this.DashboardDetailHeading = "License Expiry Dates";
          this.excel_title = "license-expiry-date-list";
          this.ExpiryType = "License";
        }
        if (ExpiryDatesData == 5) {
          this.ExpiryDatesList = this.ExpiryDatesArray.cpc_expiry_Arr;
          this.DashboardDetailHeading = "CPC Expiry Dates";
          this.excel_title = "cpc-expiry-date-list";
          this.ExpiryType = "CPC";
        }
        if (ExpiryDatesData == 6) {
          this.ExpiryDatesList = this.ExpiryDatesArray.adr_expiry_Arr;
          this.DashboardDetailHeading = "ADR Expiry Dates";
          this.excel_title = "adr-expiry-date-list";
          this.ExpiryType = "ADR";
        }
        this.ExpiryDatesList.forEach((element) => {
          var obj = {};
          obj["Vehicle/Driver"] = element.vrm
            ? element.vrm
            : element.forename + " " + element.surname;
          if (element.vrm) {
            if (this.ExpiryType == "MOT") {
              obj["Expiry Date"] = this.$options.filters.date(element.mot_due);
            }
            if (this.ExpiryType == "TAX") {
              obj["Expiry Date"] = this.$options.filters.date(element.tax_due);
            }
            if (this.ExpiryType == "Insurance") {
              obj["Expiry Date"] = this.$options.filters.date(
                element.insurance_expiry
              );
            }
            if (this.ExpiryType == "Service") {
              obj["Expiry Date"] = this.$options.filters.date(
                element.nextservice_date
              );
            }
          } else {
            if (this.ExpiryType == "License") {
              obj["Expiry Date"] = this.$options.filters.date(
                element.license_expiry
              );
            }
            if (this.ExpiryType == "CPC") {
              obj["Expiry Date"] = this.$options.filters.date(
                element.cpc_expiry
              );
            }
            if (this.ExpiryType == "ADR") {
              obj["Expiry Date"] = this.$options.filters.date(
                element.adr_expiry
              );
            }
          }

          this.excel_data.push(obj);
        });
        this.ShowDashboardDetailPopup = true;
        this.expiryDatesList = true;
      }
      ExpiryDatesData = "";
    },
    selectedDriverPoints(DriverPointsData) {
      if (DriverPointsData >= 0) {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (DriverPointsData == 0) {
          this.DriverPointsList = this.DriverPointsArray.driver_data_1;
          this.excel_title = "0-3-drivers-point-list";
          this.DashboardDetailHeading = "Drivers Point (0-3)";
        }
        if (DriverPointsData == 1) {
          this.DriverPointsList = this.DriverPointsArray.driver_data_2;
          this.excel_title = "4-6-drivers-point-list";
          this.DashboardDetailHeading = "Drivers Point (4-6)";
        }
        if (DriverPointsData == 2) {
          this.DriverPointsList = this.DriverPointsArray.driver_data_3;
          this.excel_title = "7-9-drivers-point-list";
          this.DashboardDetailHeading = "Drivers Point (7-9)";
        }
        if (DriverPointsData == 3) {
          this.DriverPointsList = this.DriverPointsArray.driver_data_4;
          this.excel_title = "10-12-drivers-point-list";
          this.DashboardDetailHeading = "Drivers Point (10-12)";
        }
        if (DriverPointsData == 4) {
          this.DriverPointsList = this.DriverPointsArray.driver_data_5;
          this.excel_title = "12-more-drivers-point-list";
          this.DashboardDetailHeading = "Drivers Point (12+)";
        }
        this.DriverPointsList.forEach((element) => {
          var obj = {};
          obj["Driver"] = element.forename + " " + element.surname;
          obj["Penality Points"] =
            element.penality_points != "" ? element.penality_points : 0;
          this.excel_data.push(obj);
        });
        this.ShowDashboardDetailPopup = true;
        this.driversPointsList = true;
      }
      DriverPointsData = "";
    },
    selectedVehiclesByAge(VehiclesByAgeData) {
      if (VehiclesByAgeData >= 0) {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (VehiclesByAgeData == 0) {
          this.VehicleByAgeList = this.VehicleByAgeArray.vehicle_data_1;
          this.excel_title = "0-3-vehicles-by-age-list";
          this.DashboardDetailHeading = "Vehicles by Age (0-3)";
        }
        if (VehiclesByAgeData == 1) {
          this.VehicleByAgeList = this.VehicleByAgeArray.vehicle_data_2;
          this.excel_title = "4-6-vehicles-by-age-list";
          this.DashboardDetailHeading = "Vehicles by Age (4-6)";
        }
        if (VehiclesByAgeData == 2) {
          this.VehicleByAgeList = this.VehicleByAgeArray.vehicle_data_3;
          this.excel_title = "7-9-vehicles-by-age-list";
          this.DashboardDetailHeading = "Vehicles by Age (7-9)";
        }
        if (VehiclesByAgeData == 3) {
          this.VehicleByAgeList = this.VehicleByAgeArray.vehicle_data_4;
          this.excel_title = "10-more-vehicles-by-age-list";
          this.DashboardDetailHeading = "Vehicles by Age (9+)";
        }
        this.VehicleByAgeList.forEach((element) => {
          var obj = {};
          obj["Vehicle"] = element.vrm;
          obj["Registration Year"] = element.year;
          obj["Age"] = element.vehicle_age;
          this.excel_data.push(obj);
        });
        this.ShowDashboardDetailPopup = true;
        this.vehiclesByAgeList = true;
      }
      VehiclesByAgeData = "";
    },
    selectedCheckFailureByDriver() {
      if (
        typeof CheckFailureByDriverData != "undefined" &&
        CheckFailureByDriverData != ""
      ) {
        this.setAllPopupStatus();
        this.ShowDashboardDetailPopup = true;
        this.CheckFailureByCheckNameList =
          this.CheckFailureByDriverArray[CheckFailureByDriverData].check_list;
        this.excel_data = [];
        this.CheckFailureByCheckNameList.forEach((element) => {
          var obj = {};
          obj["Check Name"] = element.check_name;
          obj["Vehicle"] = element.vrm;
          obj["Notes"] = element.notes;
          this.excel_data.push(obj);
        });
        this.checkFailureByDriverList = true;
        this.excel_title =
          this.CheckFailureByDriverArray[CheckFailureByDriverData].name +
          "-check-failure-list";
        this.DashboardDetailHeading =
          this.CheckFailureByDriverArray[CheckFailureByDriverData].name +
          " Check Failures";
      }
      CheckFailureByDriverData = "";
    },
    selectedCheckFailureByCheck() {
      if (
        typeof CheckFailureByCheckData != "undefined" &&
        CheckFailureByCheckData != ""
      ) {
        this.setAllPopupStatus();
        this.ShowDashboardDetailPopup = true;
        this.CheckFailureByCheckDriverList =
          this.CheckFailureByCheckArray[CheckFailureByCheckData].driver_list;
        this.excel_data = [];
        this.CheckFailureByCheckDriverList.forEach((element) => {
          var obj = {};
          obj["Driver"] = element.driver_name;
          obj["Vehicle"] = element.vrm;
          obj["Notes"] = element.notes;
          this.excel_data.push(obj);
        });

        this.checkFailureByCheckList = true;
        this.excel_title =
          this.CheckFailureByCheckArray[CheckFailureByCheckData].name +
          "-check-failure-list";
        this.DashboardDetailHeading =
          this.CheckFailureByCheckArray[CheckFailureByCheckData].name +
          " Check Failures";
      }
      CheckFailureByCheckData = "";
    },
    selectedDriverAssignment() {
      if (typeof DriverAssignData != "undefined" && DriverAssignData != "") {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (DriverAssignData == 0) {
          this.getOnDemondData("driverassigned");
        }
        if (DriverAssignData == 1) {
          this.getOnDemondData("driverunassigned");
        }
        this.ShowDashboardDetailPopup = true;
      }
      DriverAssignData = "";
    },
    selectedVehicleAssignment() {
      if (typeof VehicleAssignData != "undefined" && VehicleAssignData != "") {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (VehicleAssignData == 0) {
          this.getOnDemondData("assigned");
        }
        if (VehicleAssignData == 1) {
          this.getOnDemondData("unassigned");
        }
        this.ShowDashboardDetailPopup = true;
      }
      VehicleAssignData = "";
    },
    selectedDriverByType() {
      if (typeof DriverByTypeData != "undefined" && DriverByTypeData != "") {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (DriverByTypeData == 0) {
          this.getOnDemondData("driverfit");
        }
        if (DriverByTypeData == 1) {
          this.getOnDemondData("driverunfit");
        }
        this.ShowDashboardDetailPopup = true;
      }
      DriverByTypeData = "";
    },
    getOnDemondData(type) {
      Axios.post(Endpoints.Dashboard.DashboardReportData, {
        token: localStorage.getItem("token"),
        type: type,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
          if (type == "driverassigned") {
            var DriverAssignedVehicles = [];
          if (this.DashboardReportData.DriverAssignedArr.length > 0) {
              this.DashboardReportData.DriverAssignedArr.forEach((element) => {
                element.driver_vehicle.forEach((element2) => {
                  var vehicleDriver = element2.vehicle.vrm+"-"+element.id;
                  if(!DriverAssignedVehicles.includes(vehicleDriver)){

                    var obj2 = {};
                    var obj = {};
                    obj2["driver"] = element;
                    obj2["vehicle"] = element2.vehicle;
                    this.DriverAssignedVehicles.push(obj2);

                    DriverAssignedVehicles.push(vehicleDriver);

                    var AssignVehicles = "";
                    element.driver_vehicle.forEach((element2) => {
                      AssignVehicles =
                        AssignVehicles == ""
                          ? element2.vehicle.vrm
                          : AssignVehicles + ", " + element2.vehicle.vrm;
                    });
                    obj["Driver"] = element.forename + " " + element.surname;
                    obj["Vehicles"] = AssignVehicles;
                    this.excel_data.push(obj);     
                  }             
                });
              });              
            }
            this.driverAssignList = true;
            this.excel_title = "driver-assign-list";
            this.DashboardDetailHeading = "Assigned Driver List";
          }
          if (type == "driverunassigned") {
            if (this.DashboardReportData.DriverUnassignedArr.length > 0) {
              this.DashboardReportData.DriverUnassignedArr.forEach(
                (element) => {
                  var obj = {};
                  obj["Driver"] = element.forename + " " + element.surname;
                  this.excel_data.push(obj);
                }
              );
            }
            this.driverUnassignList = true;
            this.excel_title = "driver-unassign-list";
            this.DashboardDetailHeading = "Unassigned Driver List";
          }
          if (type == "vehiclesafe") {
            if (this.DashboardReportData.VehicleSafeArr.length > 0) {
              this.DashboardReportData.VehicleSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.vehiclesafeList = true;
            this.excel_title = "safe-vehicle-list";
            this.DashboardDetailHeading = "Safe To Drive Vehicle List";
          }
          if (type == "vehicleunsafe") {
            if (this.DashboardReportData.VehicleUnSafeArr.length > 0) {
              this.DashboardReportData.VehicleUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (element.driver_name) {
                  obj["Driver"] = element.driver_name;
                }
                if (!element.driver_name && !element?.driver?.driver?.forename) {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.vehicleunsafeList = true;
            this.excel_title = "unsafe-vehicle-list";
            this.DashboardDetailHeading = "Un-Safe To Drive Vehicle List";
          }
          if (type == "vehiclewarning") {
            if (this.DashboardReportData.VehicleWarningArr.length > 0) {
              this.DashboardReportData.VehicleWarningArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.vehiclesafewithwarningList = true;
            this.excel_title = "safe-vehicle-list";
            this.DashboardDetailHeading =
              "Safe with Warning To Drive Vehicle List";
          }
          if (type == "driverfit") {
            if (this.DashboardReportData.FitDriverArr.length > 0) {
              this.DashboardReportData.FitDriverArr.forEach((element) => {
                var obj = {};
                obj["Driver"] = element.forename + " " + element.surname;
                this.excel_data.push(obj);
              });
            }
            this.driverFitList = true;
            this.excel_title = "driver-fit-list";
            this.DashboardDetailHeading = "Authorised To Drive Driver List";
          }
          if (type == "driverunfit") {
            if (this.DashboardReportData.UnfitDriverArr.length > 0) {
              this.DashboardReportData.UnfitDriverArr.forEach((element) => {
                var obj = {};
                obj["Driver"] = element.forename + " " + element.surname;
                obj["Reason"] = element.unfit_reason;
                this.excel_data.push(obj);
              });
            }
            this.driverUnfitList = true;
            this.excel_title = "driver-unfit-list";
            this.DashboardDetailHeading = "Unauthorised To Drive Driver List";
          }
          if (type == "assigned") {
            if (this.DashboardReportData.VehicleAssignedArr.length > 0) {
              this.DashboardReportData.VehicleAssignedArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (!element?.driver?.driver?.forename) {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.vehicleAssignList = true;
            this.excel_title = "vehicle-assign-list";
            this.DashboardDetailHeading = "Assigned Vehicle List";
          }
          if (type == "unassigned") {
            if (this.DashboardReportData.VehicleUnassignedArr.length > 0) {
              this.DashboardReportData.VehicleUnassignedArr.forEach(
                (element) => {
                  var obj = {};
                  obj["Vehicle"] = element.vrm;
                  this.excel_data.push(obj);
                }
              );
            }
            this.vehicleUnassignList = true;
            this.excel_title = "vehicle-unassign-list";
            this.DashboardDetailHeading = "Unassigned Vehicle List";
          }
        }
      });
    },
    selectedVehicleByType() {
      if (typeof VehicleByTypeData != "undefined" && VehicleByTypeData != "") {
        this.setAllPopupStatus();
        this.excel_data = [];
        if (VehicleByTypeData == 1) {
          this.getOnDemondData("vehiclesafe");
        }
        if (VehicleByTypeData == 2) {
          this.getOnDemondData("vehiclewarning");
        }
        if (VehicleByTypeData == 3) {
          this.getOnDemondData("vehicleunsafe");
        }
        this.ShowDashboardDetailPopup = true;
      }
      VehicleByTypeData = "";
    },
    GetTotalStats(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.fromDate = this.TotalStatsSearch.fromDate;
        obj.toDate = this.TotalStatsSearch.toDate;
      }
      this.ShowLoader = true;
      Axios.post(Endpoints.Report.TotalStats, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          var data = Response.data.TotalStats;
          this.TotalStats = [];
          this.TotalStats.push(["", ""]);
          this.TotalStats.push(["Vehicle", data["Vehicles"]]);
          this.TotalStats.push(["Drivers", data["Drivers"]]);
          this.TotalStats.push(["Checks", data["Checks"]]);
          this.TotalStats.push(["Documents", data["Documents"]]);
        }
      });
    },
    GetTotalExpires(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.fromDate = this.TotalExpireSearch.fromDate;
        obj.toDate = this.TotalExpireSearch.toDate;
      }
      Axios.post(Endpoints.Report.TotalExpire, obj).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.TotalStats;
          this.ExpiryDatesChart.chartData = [];
          this.ExpiryDatesChart.chartData.push(["", ""]);
          this.ExpiryDatesArray = Response.data.TotalStats;
          /*this.TotalExpire.push(['MOT',data['mot_due']]);
				this.TotalExpire.push(['TAX',data['tax_due']]);
				this.TotalExpire.push(['Insurance',data['insurance_expiry']]);
				this.TotalExpire.push(['Service',data['nextservice_date']]);
				this.TotalExpire.push(['Licence',data['license_expiry']]);
				this.TotalExpire.push(['CPC',data['cpc_expiry']]);
				this.TotalExpire.push(['ADR',data['adr_expiry']]);*/
          this.ExpiryDatesChart.chartData.push([
            "MOT",
            {
              v: data["mot_due"],
              f: data["mot_due"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "TAX",
            {
              v: data["tax_due"],
              f: data["tax_due"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "Insurance",
            {
              v: data["insurance_expiry"],
              f: data["insurance_expiry"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "Service",
            {
              v: data["nextservice_date"],
              f: data["nextservice_date"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "Licence",
            {
              v: data["license_expiry"],
              f: data["license_expiry"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "CPC",
            {
              v: data["cpc_expiry"],
              f: data["cpc_expiry"],
            },
          ]);
          this.ExpiryDatesChart.chartData.push([
            "ADR",
            {
              v: data["adr_expiry"],
              f: data["adr_expiry"],
            },
          ]);
        }
      });
    },
    GetDriverPoints() {
      Axios.post(Endpoints.Report.DriverPoints, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.DriverPoints;
          this.DriverPointsChart.chartData = [];
          this.DriverPointsChart.chartData.push(["", ""]);
          this.DriverPointsArray = Response.data.DriverPoints;
          /*this.DriverPoints.push(['0-3',data['0-3']]);
				this.DriverPoints.push(['4-6',data['4-6']]);
				this.DriverPoints.push(['7-9',data['7-9']]);
				this.DriverPoints.push(['10-12',data['10-12']]);
				this.DriverPoints.push(['12-more',data['12-more']]); */
          this.DriverPointsChart.chartData.push([
            "0-3",
            { v: data["0-3"], f: data["0-3"] },
          ]);
          this.DriverPointsChart.chartData.push([
            "4-6",
            { v: data["4-6"], f: data["4-6"] },
          ]);
          this.DriverPointsChart.chartData.push([
            "7-9",
            { v: data["7-9"], f: data["7-9"] },
          ]);
          this.DriverPointsChart.chartData.push([
            "10-12",
            { v: data["10-12"], f: data["10-12"] },
          ]);
          this.DriverPointsChart.chartData.push([
            "12-more",
            {
              v: data["12-more"],
              f: data["12-more"],
            },
          ]);
        }
      });
    },
    GetCheckFailures(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.fromDate = this.CheckFailuresSearch.fromDate;
        obj.toDate = this.CheckFailuresSearch.toDate;
      }
      Axios.post(Endpoints.Report.CheckFailures, obj).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.CheckFailures;
          this.CheckFailureByCheckArray = [];
          this.CheckFailureByDriverArray = [];

          this.CheckFailureByCheckChart.chartData = [];
          this.CheckFailureByCheckChart.chartData.push(["", ""]);

          for (var index in data) {
            var element = data[index];
            //this.CheckFailures.push([element['name'],element['total']]);
            this.CheckFailureByCheckChart.chartData.push([
              element["name"],
              {
                v: element["total"],
                f: element["total"],
              },
            ]);

            var obj = {};
            obj["name"] = element["name"];
            obj["notes"] = element["notes"];
            obj["driver_list"] = element["driverData"];
            obj["total_driver"] = element["total"];
            this.CheckFailureByCheckArray.push(obj);
          }

          var data2 = Response.data.CheckFailuresByDrivers;
          this.CheckFailureByDriverChart.chartData = [];
          this.CheckFailureByDriverChart.chartData.push(["", ""]);
          for (var index in data2) {
            var element = data2[index];
            //this.CheckFailuresByDrivers.push([element['name'],element['total']]);
            this.CheckFailureByDriverChart.chartData.push([
              element["name"],
              {
                v: element["total"],
                f: element["total"],
              },
            ]);

            var driverObj = {};
            driverObj["name"] = element["name"];
            driverObj["check_list"] = element["checkData"];
            driverObj["total_check"] = element["total"];
            this.CheckFailureByDriverArray.push(driverObj);
          }
        }
      });
    },
    GetTotalWarningFailure(type = "") {
      var obj = { token: localStorage.getItem("token") };
      /*if (type == "search") {
          	obj.fromDate = this.TotalWarningFailureSearch.fromDate;
          	obj.toDate = this.TotalWarningFailureSearch.toDate;
        }*/
      Axios.post(Endpoints.Report.TotalWarningFailure, obj).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.CheckFailures;
          this.TotalWarningFailureChart.chartData = [];
          this.TotalWarningFailureChart.chartData.push([
            "",
            "Warning",
            "Failure",
          ]);
          for (var index in data) {
            var element = data[index];
            /*this.TotalWarningFailureChart.chartData.push([index,element['warning'],element['failure']]); */
            this.TotalWarningFailureChart.chartData.push([
              index,
              {
                v: element["warning"],
                f: element["warning"],
              },
              {
                v: element["failure"],
                f: element["failure"],
              },
            ]);
            var warningObj = {};
            warningObj["month"] = index;
            warningObj["failureDriverArr"] = element["failureDriverArr"];
            warningObj["warningDriverArr"] = element["warningDriverArr"];
            this.WarningFailureDataArray.push(warningObj);
          }
        }
      });
    },
    GetVehiclesByAge() {
      Axios.post(Endpoints.Report.VehiclesByAge, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          var data = Response.data.VehiclesByAge;

          this.VehicleByAgeChart.chartData = [];
          this.VehicleByAgeChart.chartData.push(["", ""]);
          this.VehicleByAgeArray = Response.data.VehiclesByAge;
          /*this.VehiclesByAge.push(['0-3',data['0-3']]);
				this.VehiclesByAge.push(['4-6',data['4-6']]);
				this.VehiclesByAge.push(['7-9',data['7-9']]);
				this.VehiclesByAge.push(['9+',data['10-more']]);*/

          this.VehicleByAgeChart.chartData.push([
            "0-3",
            { v: data["0-3"], f: data["0-3"] },
          ]);
          this.VehicleByAgeChart.chartData.push([
            "4-6",
            { v: data["4-6"], f: data["4-6"] },
          ]);
          this.VehicleByAgeChart.chartData.push([
            "7-9",
            { v: data["7-9"], f: data["7-9"] },
          ]);
          this.VehicleByAgeChart.chartData.push([
            "9+",
            {
              v: data["10-more"],
              f: data["10-more"],
            },
          ]);
        }
      });
    },
    GetVehiclesListForAssign() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Vehicles = Response.data.vehicles;
        }
      });
    },
    GetVehiclesListAll() {
      var obj = { token: localStorage.getItem("token")};
      Axios.post(Endpoints.Vehicle.ListPlain, obj).then((Response) => {
        if (Response?.data?.success) {
          this.AllVehicles = Response.data.vehicles;
        }
      });
    },
    GetVehiclesByMileage(type = "") {
      var obj = {
        token: localStorage.getItem("token"),
        category: "vehicle",
        sub_category: "service",
      };
      if (type == "search") {
        obj.VehicleId = this.VehiclesByMileageSearch.VehicleId;
      }
      Axios.post(Endpoints.Report.VehiclesByMileage, obj).then((Response) => {
        if (Response?.data?.success) {
          this.VehiclesByMileage = {};
          this.VehiclesByCost = {};
          var data = Response.data.services;
          if (data.length > 1) {
            this.VehiclesByMileage = {};
            this.VehiclesByMileage.series = [
              { name: this.MileageUnit, data: [] },
              { name: "", data: [] },
            ];
            this.areaspalinechart.chartOptions.xaxis.categories = [];

            this.VehiclesByCost = {};
            this.VehiclesByCost.series = [
              { name: "Cost("+this.currency_type+")", data: [] },
              { name: "Total Cost("+this.currency_type+")", data: [] },
            ];
            this.areaspalinechart.chartOptions.xaxis.categories = [];

            data.forEach((element, index) => {
              this.VehiclesByMileage.series[0]["data"].push(
                +element["mileage"]
              );

              this.VehiclesByCost.series[0]["data"].push(+element["cost"]);
              this.VehiclesByCost.series[1]["data"].push(+element["costtotal"]);

              this.areaspalinechart.chartOptions.xaxis.categories.push(
                element["date3"]
              );
            });
          }
        }
      });
    },
  },
};
</script>

<style type="text/css">
.custom-scrollbar thead th.heading-padding-left {
  padding-left: 0.75rem !important;
}
g {
  cursor: pointer;
}
.margin-top-table {
  margin-top: -2px;
}
.margin-auto {
  margin: 0 auto;
}
.vehicle-details-modal {
  width: 100%;
}
.margin-right-auto {
  margin-right: auto !important;
}
.detail-link {
  color: #000;
}
.detail-link:hover {
  color: #000;
}
#showOwnerDetails .modal-header {
  border-bottom: 0px !important;
}
#showOwnerDetails .modal-title {
  font-size: 14px !important;
}
.modal-table .table th,
.table td {
  padding: 0.75rem !important;
}
.vehicle-info-modal,
.owner-info-modal {
  padding-top: 0px !important;
}
#showVehicleDetails .modal-header {
  border-bottom: 0px !important;
}
#showVehicleDetails .modal-title {
  font-size: 14px !important;
}
.vehicle-safe {
  color: #51bb25;
  font-size: 20px;
}
.vehicle-unsafe {
  color: #f00;
  font-size: 20px;
}
.vehicle-warning {
  color: #f3d541;
  font-size: 20px;
}
</style>
